import React from 'react';
import FamilyUserRoleTable from './FamilyUserRoleTable';
import FamilyUserRoleUpsert from './FamilyUserRoleUpsert';

const FamilyUserRoleTab: React.FC<{}> = () => {
  const [roleToUpdate, setRoleToUpdate] = React.useState('');
  const [toggleAddRole, setToggleAddRole] = React.useState(false);

  return (
    <>
      <h3 className='text-center'>User Types</h3>
      {toggleAddRole ? (
        <FamilyUserRoleUpsert
          roleIdToUpdate={roleToUpdate}
          callback={() => setToggleAddRole(false)}
          cancelBtnClick={() => setToggleAddRole(false)}
        />
      ) : (
        <FamilyUserRoleTable
          editBtnClick={(roleId: string) => {
            setRoleToUpdate(roleId);
            setToggleAddRole(true);
          }}
          addRoleBtnClick={() => {
            setRoleToUpdate('');
            setToggleAddRole(true);
          }}
        />
      )}
    </>
  );
};

export default FamilyUserRoleTab;
